module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.hasAdminRole) ? _c('div', {
    staticClass: "admin-view"
  }, [_c('login', {
    on: {
      "submit": _vm.submitLogin
    }
  })], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-749557d9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/views/permissions/AdminLogin.vue
// module id = 1953
// module chunks = 0